import React from 'react';
import { Button, IconButton, InputAdornment, Stack, TextField, Tooltip } from '@mui/material';
import { CloseRounded, QrCodeScannerRounded, SearchRounded } from '@mui/icons-material';

export default function SearchBar({ value, onChange, onSearch, disabled }) {
  return (
    <Stack direction="row" spacing={0.8} alignItems="stretch">
      <TextField
        fullWidth
        autoFocus
        value={value}
        disabled={disabled}
        onChange={(event) => onChange?.(event.target.value)}
        onKeyDown={(event) => {
          if (event.key === 'Enter') {
            event.preventDefault();
            onSearch?.();
          }
        }}
        placeholder="Buscar productos por nombre, SKU o código…"
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchRounded sx={{ color: '#234c79' }} />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment position="end">
              {value ? (
                <Tooltip title="Limpiar búsqueda">
                  <IconButton size="small" onClick={() => onChange?.('')} disabled={disabled}>
                    <CloseRounded fontSize="small" />
                  </IconButton>
                </Tooltip>
              ) : null}
              <Tooltip title="Puede escanear directamente desde el PDV">
                <QrCodeScannerRounded sx={{ ml: 0.45, color: '#6c83a0' }} />
              </Tooltip>
            </InputAdornment>
          ),
          sx: {
            height: 52,
            '@media (max-height: 820px)': { height: 46 },
            bgcolor: '#fff',
            borderRadius: 1.9,
            fontWeight: 750,
            boxShadow: '0 4px 14px rgba(28, 66, 108, .06)',
            '& fieldset': { borderColor: '#d5e0ec' },
            '&:hover fieldset': { borderColor: '#aebfd2 !important' },
            '&.Mui-focused fieldset': { borderColor: '#2d7ff9 !important', borderWidth: '1.5px !important' },
          },
        }}
      />
      <Button
        variant="contained"
        startIcon={<SearchRounded />}
        disabled={disabled}
        onClick={() => onSearch?.()}
        sx={{
          minWidth: 108,
          borderRadius: 1.8,
          fontWeight: 900,
          px: 1.35,
          bgcolor: '#1772e8',
          boxShadow: '0 6px 16px rgba(23,114,232,.18)',
          '&:hover': { bgcolor: '#0f63cf' },
          '@media (max-height: 820px)': { minWidth: 98, minHeight: 46 },
        }}
      >
        Buscar
      </Button>
    </Stack>
  );
}
